import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { LogoMark } from "@/components/LogoMark";
import { StoreFooter } from "@/components/StoreFooter";

function StorefrontHeader() {
  return (
    <>
      <div className="gov-strip">
        <span className="tri"><span className="b saffron" /><span className="b white" /><span className="b green" /></span>
        <Link to="/about">About us</Link>
        <Link to="/contact">Contact us</Link>
        <Link to="/gi-information">GI information</Link>
        <Link to="/return-policy">Return policy</Link>
      </div>
      <header className="store-header">
        <Link to="/" className="store-brand" data-testid="brand-home">
          <LogoMark small />
          <span>GI Bharat<small>By True Vision Welfare Society · Authorised-user services</small></span>
        </Link>
        <div className="header-actions">
          <Link to="/authorised-users">Authorised users</Link>
          <Link to="/login">Login</Link>
        </div>
      </header>
    </>
  );
}

export default function ReturnPolicy() {
  const [policy, setPolicy] = useState(null);
  useEffect(() => { api.get("/return-policy").then(r => setPolicy(r.data)).catch(() => {}); }, []);
  if (!policy) return <main className="storefront"><StorefrontHeader /><div className="pd-shell" data-testid="rp-loading">Loading…</div></main>;
  return (
    <main className="storefront return-policy-page" data-testid="return-policy-page">
      <StorefrontHeader />
      <section className="rp-hero">
        <div className="rp-hero-inner">
          <span className="rp-eyebrow"><ShieldCheck size={13} /> RETURNS · REFUNDS · CANCELLATION</span>
          <h1>{policy.title}</h1>
          <p>{policy.summary}</p>
        </div>
      </section>
      <div className="rp-body">
        {(policy.sections || []).map((s, i) => (
          <section key={i} className="rp-section" data-testid={`rp-section-${i}`}>
            <h2>{s.heading}</h2>
            <p>{s.body}</p>
          </section>
        ))}
        {policy.contact && (
          <section className="rp-contact" data-testid="rp-contact">
            <b>Questions?</b>
            <p>Email us at <a href={`mailto:${policy.contact}`}>{policy.contact}</a> with your order ID.</p>
          </section>
        )}
        <Link to="/" className="pd-back" style={{ marginTop: 16, display: "inline-flex" }}><ChevronLeft size={14} /> Back to home</Link>
      </div>
      <StoreFooter />
    </main>
  );
}
